module.exports = __webpack_public_path__ + "img/default.bc7f1fc9.png";